import { c as _c } from "react/compiler-runtime";
import { Button, Close, Menu, Search, ShoppingCart, SpreadshirtLogo, SpreadshirtProLogo } from '@sprd/sprd-component-kit/v2';
import { NavActiveState, NavItem, NavTeaser, Header as Shell } from '@sprd/spreadshirt-shell';
import { Suspense, useRef, useState } from 'react';
import clsx from 'clsx';
import { useAtom, useSetAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { CustomerAttentionToolSlot } from '@/types/amplience';
import { HeaderContent } from '@/types/headerHierarchy';
import { HeaderContentPro } from '@/types/spreadshirtProHeader';
import { useCart } from '@/hooks/useCartHooks';
import { useMenuReset } from '@/hooks/useMenuReset';
import { usePageChrome } from '@/hooks/usePageChrome';
import DynamicIcon from '@/components/Common/DynamicIcon';
import HeaderBanner from '@/components/HeaderBanner/HeaderBanner';
import NestedPromoBanner from '@/components/HeaderBanner/NestedPromoBanner';
import { Link } from '@/i18n/navigation';
import { basketAtom, countrySwitcherAtom, headerPageOverlayAtom } from '@/store/atoms';
import { isProHeaderContent } from '@/utility/headerNavigationHelpers';
import { getTotalQuantity } from '@/utility/lineItems/lineItemHelpers';
import { FavoritesPageLink } from '../FavoritesPageLink';
import { HeaderLinkAdapter } from '../HeaderLinkAdapter';
import { SearchWrapper } from '../SearchWrapper';
import { toExternalLinks, toFooterLinks, toSocialLinks } from '../headerContent';
import { LoginButton } from './LoginButton';
import { MobileSearchWrapper } from './MobileSearchWrapper';
type MobileMenuProps = {
  content: HeaderContent | HeaderContentPro;
  items: NavItem[];
  active: NavActiveState;
  resetKey: string;
  rootTeaser: NavTeaser | undefined;
  isDesignerPage: boolean;
  subDomain: string;
  sprdAccountsContext: string;
  customerAttentionToolSlot: CustomerAttentionToolSlot | null;
};
export const MobileHeader = t0 => {
  const $ = _c(136);
  const {
    content,
    items,
    active,
    resetKey,
    rootTeaser,
    isDesignerPage,
    customerAttentionToolSlot,
    subDomain,
    sprdAccountsContext
  } = t0;
  const t = useTranslations("general");
  const tRoot = useTranslations();
  const {
    data: cartAndLineItemGroups,
    isFetching
  } = useCart();
  const [isOpenBasket, setOpenBasket] = useAtom(basketAtom);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const setShowOverlay = useSetAtom(headerPageOverlayAtom);
  const setCountrySwitcherOpen = useSetAtom(countrySwitcherAtom);
  const {
    hidePromoBanner
  } = usePageChrome();
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== setShowOverlay) {
    t1 = () => {
      setMobileMenuOpen(false);
      setShowOverlay(false);
    };
    $[0] = setShowOverlay;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useMenuReset(t1);
  let t2;
  if ($[2] !== isOpenBasket || $[3] !== setOpenBasket) {
    t2 = () => setOpenBasket(!isOpenBasket);
    $[2] = isOpenBasket;
    $[3] = setOpenBasket;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleBasket = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setMobileMenuOpen(_temp);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toggleMobileMenu = t3;
  let t4;
  if ($[6] !== showMobileSearch) {
    t4 = () => setShowMobileSearch(!showMobileSearch);
    $[6] = showMobileSearch;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const toggleMobileSearch = t4;
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== active || $[9] !== cartAndLineItemGroups?.lineItemGroups || $[10] !== content || $[11] !== customerAttentionToolSlot || $[12] !== hidePromoBanner || $[13] !== isDesignerPage || $[14] !== isFetching || $[15] !== items || $[16] !== mobileMenuOpen || $[17] !== resetKey || $[18] !== rootTeaser || $[19] !== setCountrySwitcherOpen || $[20] !== setShowOverlay || $[21] !== showMobileSearch || $[22] !== sprdAccountsContext || $[23] !== subDomain || $[24] !== t || $[25] !== tRoot || $[26] !== toggleBasket || $[27] !== toggleMobileSearch) {
    const totalQuantity = getTotalQuantity(cartAndLineItemGroups?.lineItemGroups);
    const socials = toSocialLinks(content);
    let t22;
    if ($[46] !== content) {
      t22 = <Link href="/" className="text-xl font-bold">{isProHeaderContent(content) ? <SpreadshirtProLogo className="w-[140px] sm:w-[160px]" aria-label="Spreadshirt Pro" /> : <SpreadshirtLogo className="w-[140px] sm:w-[160px]" aria-label="Spreadshirt" />}</Link>;
      $[46] = content;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    let t23;
    if ($[48] !== isDesignerPage || $[49] !== setShowOverlay) {
      t23 = isDesignerPage ? undefined : <Suspense><SearchWrapper onFocus={() => setShowOverlay(true)} onBlur={() => setShowOverlay(false)} /></Suspense>;
      $[48] = isDesignerPage;
      $[49] = setShowOverlay;
      $[50] = t23;
    } else {
      t23 = $[50];
    }
    let t24;
    if ($[51] !== isDesignerPage || $[52] !== t || $[53] !== toggleMobileSearch) {
      t24 = !isDesignerPage && <Button variant="plain" aria-label={t("search")} onClick={toggleMobileSearch} className="sm-md:hidden"><Search className="size-6" /></Button>;
      $[51] = isDesignerPage;
      $[52] = t;
      $[53] = toggleMobileSearch;
      $[54] = t24;
    } else {
      t24 = $[54];
    }
    let t25;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = <Suspense><FavoritesPageLink /></Suspense>;
      $[55] = t25;
    } else {
      t25 = $[55];
    }
    const t26 = t("a11y.cart", {
      count: totalQuantity
    });
    let t27;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <ShoppingCart className="size-6" />;
      $[56] = t27;
    } else {
      t27 = $[56];
    }
    const t28 = totalQuantity > 99 ? "-right-3" : "-right-1";
    const t29 = totalQuantity === 0 ? "hidden" : "";
    let t30;
    if ($[57] !== t28 || $[58] !== t29) {
      t30 = clsx("absolute -top-1 flex h-5 min-w-5 items-center justify-center rounded-l-xl rounded-r-xl bg-brand-green-dark px-1 text-xs text-white", t28, t29);
      $[57] = t28;
      $[58] = t29;
      $[59] = t30;
    } else {
      t30 = $[59];
    }
    let t31;
    if ($[60] !== totalQuantity) {
      t31 = totalQuantity > 99 ? <span>99+</span> : <span>{totalQuantity}</span>;
      $[60] = totalQuantity;
      $[61] = t31;
    } else {
      t31 = $[61];
    }
    let t32;
    if ($[62] !== t30 || $[63] !== t31) {
      t32 = <span aria-hidden={true} className={t30}>{t31}</span>;
      $[62] = t30;
      $[63] = t31;
      $[64] = t32;
    } else {
      t32 = $[64];
    }
    let t33;
    if ($[65] !== isFetching || $[66] !== t26 || $[67] !== t32 || $[68] !== toggleBasket) {
      t33 = <Button variant="plain" className="relative" onClick={toggleBasket} aria-label={t26} aria-live="off" aria-busy={isFetching}>{t27}{t32}</Button>;
      $[65] = isFetching;
      $[66] = t26;
      $[67] = t32;
      $[68] = toggleBasket;
      $[69] = t33;
    } else {
      t33 = $[69];
    }
    let t34;
    if ($[70] !== mobileMenuOpen || $[71] !== t) {
      t34 = mobileMenuOpen ? t("a11y.closeMenu") : t("a11y.openMenu");
      $[70] = mobileMenuOpen;
      $[71] = t;
      $[72] = t34;
    } else {
      t34 = $[72];
    }
    let t35;
    if ($[73] !== mobileMenuOpen) {
      t35 = mobileMenuOpen ? <Close className="size-6" /> : <Menu className="size-6" />;
      $[73] = mobileMenuOpen;
      $[74] = t35;
    } else {
      t35 = $[74];
    }
    let t36;
    if ($[75] !== t34 || $[76] !== t35) {
      t36 = <Button variant="plain" onClick={toggleMobileMenu} aria-label={t34}>{t35}</Button>;
      $[75] = t34;
      $[76] = t35;
      $[77] = t36;
    } else {
      t36 = $[77];
    }
    let t37;
    if ($[78] !== t24 || $[79] !== t33 || $[80] !== t36) {
      t37 = <>{t24}{t25}{t33}{t36}</>;
      $[78] = t24;
      $[79] = t33;
      $[80] = t36;
      $[81] = t37;
    } else {
      t37 = $[81];
    }
    let t38;
    if ($[82] !== isDesignerPage || $[83] !== showMobileSearch) {
      t38 = isDesignerPage ? undefined : <MobileSearchWrapper showMobileSearch={showMobileSearch} setShowMobileSearch={setShowMobileSearch} containerRef={containerRef} />;
      $[82] = isDesignerPage;
      $[83] = showMobileSearch;
      $[84] = t38;
    } else {
      t38 = $[84];
    }
    if ($[85] !== t22 || $[86] !== t23 || $[87] !== t37 || $[88] !== t38) {
      t21 = <Shell.Bar variant="mobile" ref={containerRef} logo={t22} search={t23} actions={t37} below={t38} />;
      $[85] = t22;
      $[86] = t23;
      $[87] = t37;
      $[88] = t38;
      $[89] = t21;
    } else {
      t21 = $[89];
    }
    T0 = Shell.MobileNav;
    t7 = items;
    t8 = active;
    t9 = resetKey;
    t10 = mobileMenuOpen;
    t11 = setMobileMenuOpen;
    t12 = HeaderLinkAdapter;
    if ($[90] !== t) {
      t13 = t("a11y.mobileNavigation");
      $[90] = t;
      $[91] = t13;
    } else {
      t13 = $[91];
    }
    if ($[92] !== t) {
      t14 = t("a11y.closeMenu");
      $[92] = t;
      $[93] = t14;
    } else {
      t14 = $[93];
    }
    let t39;
    if ($[94] !== hidePromoBanner) {
      t39 = !hidePromoBanner && <NestedPromoBanner />;
      $[94] = hidePromoBanner;
      $[95] = t39;
    } else {
      t39 = $[95];
    }
    if ($[96] !== customerAttentionToolSlot || $[97] !== t39) {
      t15 = <HeaderBanner customerAttentionToolSlot={customerAttentionToolSlot}>{t39}</HeaderBanner>;
      $[96] = customerAttentionToolSlot;
      $[97] = t39;
      $[98] = t15;
    } else {
      t15 = $[98];
    }
    if ($[99] !== sprdAccountsContext || $[100] !== subDomain) {
      t16 = <Suspense><LoginButton subDomain={subDomain} sprdAccountsContext={sprdAccountsContext} /></Suspense>;
      $[99] = sprdAccountsContext;
      $[100] = subDomain;
      $[101] = t16;
    } else {
      t16 = $[101];
    }
    if ($[102] !== content) {
      t17 = toExternalLinks(content);
      $[102] = content;
      $[103] = t17;
    } else {
      t17 = $[103];
    }
    t18 = rootTeaser;
    let t40;
    if ($[104] !== setCountrySwitcherOpen) {
      t40 = () => setCountrySwitcherOpen(true);
      $[104] = setCountrySwitcherOpen;
      $[105] = t40;
    } else {
      t40 = $[105];
    }
    let t41;
    if ($[106] !== tRoot) {
      t41 = tRoot("countrySwitcher.countryAndCurrency");
      $[106] = tRoot;
      $[107] = t41;
    } else {
      t41 = $[107];
    }
    if ($[108] !== t40 || $[109] !== t41) {
      t19 = <button type="button" className="cursor-pointer text-sm nav-underline" onClick={t40}>{t41}</button>;
      $[108] = t40;
      $[109] = t41;
      $[110] = t19;
    } else {
      t19 = $[110];
    }
    if ($[111] !== content) {
      t20 = toFooterLinks(content);
      $[111] = content;
      $[112] = t20;
    } else {
      t20 = $[112];
    }
    t5 = content.content.menuSocials?.headline;
    t6 = socials.map(_temp2);
    $[8] = active;
    $[9] = cartAndLineItemGroups?.lineItemGroups;
    $[10] = content;
    $[11] = customerAttentionToolSlot;
    $[12] = hidePromoBanner;
    $[13] = isDesignerPage;
    $[14] = isFetching;
    $[15] = items;
    $[16] = mobileMenuOpen;
    $[17] = resetKey;
    $[18] = rootTeaser;
    $[19] = setCountrySwitcherOpen;
    $[20] = setShowOverlay;
    $[21] = showMobileSearch;
    $[22] = sprdAccountsContext;
    $[23] = subDomain;
    $[24] = t;
    $[25] = tRoot;
    $[26] = toggleBasket;
    $[27] = toggleMobileSearch;
    $[28] = T0;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
    $[40] = t21;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
  } else {
    T0 = $[28];
    t10 = $[29];
    t11 = $[30];
    t12 = $[31];
    t13 = $[32];
    t14 = $[33];
    t15 = $[34];
    t16 = $[35];
    t17 = $[36];
    t18 = $[37];
    t19 = $[38];
    t20 = $[39];
    t21 = $[40];
    t5 = $[41];
    t6 = $[42];
    t7 = $[43];
    t8 = $[44];
    t9 = $[45];
  }
  let t22;
  if ($[113] !== t5 || $[114] !== t6) {
    t22 = {
      headline: t5,
      links: t6
    };
    $[113] = t5;
    $[114] = t6;
    $[115] = t22;
  } else {
    t22 = $[115];
  }
  let t23;
  if ($[116] !== T0 || $[117] !== t10 || $[118] !== t11 || $[119] !== t12 || $[120] !== t13 || $[121] !== t14 || $[122] !== t15 || $[123] !== t16 || $[124] !== t17 || $[125] !== t18 || $[126] !== t19 || $[127] !== t20 || $[128] !== t22 || $[129] !== t7 || $[130] !== t8 || $[131] !== t9) {
    t23 = <T0 items={t7} active={t8} resetKey={t9} open={t10} onOpenChange={t11} linkComponent={t12} title={t13} closeLabel={t14} banner={t15} header={t16} externalLinks={t17} teaser={t18} footerStart={t19} footerLinks={t20} socials={t22} />;
    $[116] = T0;
    $[117] = t10;
    $[118] = t11;
    $[119] = t12;
    $[120] = t13;
    $[121] = t14;
    $[122] = t15;
    $[123] = t16;
    $[124] = t17;
    $[125] = t18;
    $[126] = t19;
    $[127] = t20;
    $[128] = t22;
    $[129] = t7;
    $[130] = t8;
    $[131] = t9;
    $[132] = t23;
  } else {
    t23 = $[132];
  }
  let t24;
  if ($[133] !== t21 || $[134] !== t23) {
    t24 = <>{t21}{t23}</>;
    $[133] = t21;
    $[134] = t23;
    $[135] = t24;
  } else {
    t24 = $[135];
  }
  return t24;
};
function _temp(prev) {
  return !prev;
}
function _temp2(social) {
  return {
    ...social,
    icon: <DynamicIcon icon={social.icon} width={24} />
  };
}